import React, { useState } from "react";
import Select from "react-select";
import { Button, Form } from "react-bootstrap";
import _ from "lodash";
import imgCamelLogo from "../../assets/images/main-logo-white.png";
import LoaderButton from "../../components/LoaderButton";
import "./CreateWebhookForm.scss";
import "./CreateBrandingForm.scss";
import { InputGroup, FormControl } from "react-bootstrap";

const CreateWebhookForm = (props) => {
  const [deliveryUrl, setDeliveryUrl] = useState("");
  const [event, setEvent] = useState(null);
  const [editing, setEditing] = useState(false);

  const [submitting, setSubmitting] = useState(false);

  React.useEffect(() => {
    if (props.subscription) {
      setDeliveryUrl(props.subscription.deliveryUrl);

      const existingOption = eventOptions.find((event) => {
        return props.subscription.eventName === event.value;
      });

      setEvent(existingOption);
      setEditing(true);
    }
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const subscriptionData = {
      tenantId: props.tenantId,
      enabledEvents: [event.value],
      deliveryUrl,
      // This is for when it's an edit usecase rather than create
      newDeliveryUrl: deliveryUrl,
      subscriptionId: props.subscription?.id,
    };
    props.onSubmit(subscriptionData);
    // props.onClose()
  };

  const isDisabled = () => {
    if (event && deliveryUrl) return false;
    return true;
  };
  const eventOptions = [
    { value: "system.item.added", label: "System Item Added" },
    { value: "system.item.updated", label: "System Item Updated" },
    { value: "recipient.item.viewed", label: "Recipient Item Viewed" }
  ];

  return (
    <Form className="create-branding-form">
      <div className="form-header">
        <img src={imgCamelLogo} alt="logo" />
        <button className="close-button" onClick={props.onClose}>
          ×
        </button>
      </div>
      <div className="main-content">
        <div className="title">{props.isEditing ? "Edit" : "Add"} Webhook</div>
        <div className="create-container">
          <div className="edit-box">
            <div className="form-group">
              {/* <label htmlFor="eventType" className="form-label">Event Type</label> */}
              <Select
                id="eventType"
                classNamePrefix="react-select"
                options={eventOptions}
                placeholder="Select Event Type"
                onChange={(value) => setEvent(value)}
                value={event}
                isDisabled={editing}
              />
            </div>

            <div className="form-group">
              {/* <label htmlFor="deliveryUrl" className="form-label">Delivery URL</label> */}
              <FormControl
                id="deliveryUrl"
                className="form-control"
                placeholder="Enter delivery URL"
                value={deliveryUrl}
                onChange={(e) => setDeliveryUrl(e.target.value)}
              />
            </div>

            <div className="actions-box">
              <Button onClick={props.onClose} variant="outline-danger" className="mr-2" size="sm">
                Cancel
              </Button>

              <LoaderButton
                disabled={isDisabled()}
                onClick={onSubmit}
                variant="outline-danger"
                className="mr-2"
                size="sm"
                isLoading={submitting}
                text={editing ? "Edit" : "Create"}
                loadingText=""
              />
            </div>
          </div>
        </div>
      </div>
    </Form>
  );
};

export default CreateWebhookForm;
